import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { Gem, ShieldCheck, Tag, Sparkles, ArrowRight } from "lucide-react";

export default function About() {
  const { settings } = useSettings();
  return (
    <div data-testid="about-page">
      <section className="relative bg-obsidian text-white">
        <img src="https://images.unsplash.com/photo-1598218940656-7126545fd283?crop=entropy&cs=srgb&fm=jpg&q=85" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative max-w-4xl mx-auto px-6 py-24 text-center">
          <p className="overline text-gold mb-3">About Us</p>
          <h1 className="font-serif text-5xl lg:text-6xl mb-5">{settings.business_name || "ChainSmart"}</h1>
          <p className="text-white/70 max-w-2xl mx-auto">{settings.tagline}</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-16 lg:py-20">
        <div className="prose max-w-none">
          <p className="text-lg leading-relaxed text-obsidian mb-6">{settings.about}</p>
          <p className="text-muted-foreground leading-relaxed mb-6">
            At ChainSmart, we believe fine jewellery should be accessible and honest. Our collection spans genuine 9Karat gold chains, sterling silver chains and beautifully crafted gold-plated pieces — each selected for its quality, finish and value.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            We are committed to transparent pricing. Every product clearly displays its MRP alongside its discounted price, so you always know exactly what you are paying for. No hidden charges, no inflated markups — just beautiful chains at fair prices.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-px bg-black/10 border border-black/10 my-14">
          {[
            { icon: Gem, t: "Genuine Materials", d: "9K gold and 925 silver, sourced responsibly." },
            { icon: Sparkles, t: "Fine Craftsmanship", d: "Each chain finished by skilled artisans." },
            { icon: Tag, t: "Honest Pricing", d: "Clear MRP and discount on every product." },
            { icon: ShieldCheck, t: "Trusted Service", d: "Support through every step of your order." },
          ].map((x) => (
            <div key={x.t} className="bg-white p-8">
              <x.icon className="w-6 h-6 text-gold-dark mb-3" />
              <h3 className="font-serif text-2xl mb-1">{x.t}</h3>
              <p className="text-sm text-muted-foreground">{x.d}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/catalogue" className="inline-flex items-center gap-2 bg-gold text-obsidian font-semibold px-8 py-3.5 hover:bg-gold-light transition-colors rounded-sm" data-testid="about-shop-btn">
            Browse Collection <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
